import React, { useEffect, createElement } from 'react';
import { HomePage } from './pages/HomePage';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://emrldco.com/NDk5NTk0.js?t=499594';
    script.setAttribute('data-noptimize', '1');
    script.setAttribute('data-cfasync', 'false');
    script.setAttribute('data-wpfc-render', 'false');
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return <HomePage data-id="element-0" />;
}